import React from 'react';
import LoginButton from '../components/LoginButton/LoginButton';

const Login = () => {
  const handleLoginSuccess = () => {
    // Redirect to Home after successful login
    
  };

  return (
    <div className="login-container">
      <h1>Login to Quality insights</h1>
      <div>
        <LoginButton onLoginSuccess={handleLoginSuccess} />
      </div>
    </div>
  );
};

export default Login;